import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'arm-info-image',
  templateUrl: './arm-info-image.component.html',
  styleUrls: ['./arm-info-image.component.less']
})
export class ArmInfoImageComponent implements OnInit {

  constructor() {
  }

  @Input() imageInfoId: string;
  @Input() refreshEventName: string;
  @Input() itemsFetchFunction: (success, failure) => void;
  @Input() items: any;

  ngOnInit(): void {
    if (!this.items) {
      this.initialImageInfo();
    }

    /*this.sharedEventService.on(this, this.refreshEventName, () => {
      this.initialImageInfo();
    });*/
  }

  private initialImageInfo(): void {
    this.items = [];

    if (this.itemsFetchFunction) {
      this.itemsFetchFunction(
        (value) => {this.items = value; },
        (error) => {}
      );
    }
  }
}
